import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_item = _resolveComponent("search-item")!
  const _component_search_state = _resolveComponent("search-state")!
  const _component_bs_search = _resolveComponent("bs-search")!

  return (_openBlock(), _createBlock(_component_bs_search, {
    placeholder: "Поиск накладной...",
    modelValue: _ctx.query,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
    loading: _ctx.is_loading,
    onInput: _ctx.debouncedSearch
  }, {
    default: _withCtx(() => [
      (_ctx.items.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createBlock(_component_search_item, {
              key: item.id,
              item: item
            }, null, 8, ["item"]))
          }), 128))
        : (_openBlock(), _createBlock(_component_search_state, {
            key: 1,
            loading: _ctx.is_loading,
            loaded: _ctx.is_loaded,
            failed: _ctx.is_failed,
            empty: _ctx.items.length === 0,
            "no-query": !Boolean(_ctx.query)
          }, null, 8, ["loading", "loaded", "failed", "empty", "no-query"]))
    ]),
    _: 1
  }, 8, ["modelValue", "loading", "onInput"]))
}